import {object, SchemaOf, string} from 'yup';

import {BusinessInfoRequestBody} from '../types/BusinessInfoRequestBody';
import {$BusinessInfoData} from './$BusinessInfoData';

export const $BusinessInfoRequestBody: SchemaOf<BusinessInfoRequestBody> = object({
  businessAddressId: string().defined().nullable(),
  businessInfoData: $BusinessInfoData.defined(),
});
